import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

const rootElement = document.getElementById("root");

// react-snap injects rendered HTML at build time. When that markup is present
// we hydrate it (preserves SEO); otherwise we mount normally.
if (rootElement.hasChildNodes() && rootElement.querySelector("[data-reactroot], header, main, section, div:not(.seo-fallback)")) {
  hydrateRoot(rootElement, tree);
} else {
  createRoot(rootElement).render(tree);
}
